import { Routers } from './Router/Routers';

function App() {
  return (
    <div className="App">
      <Routers />
    </div>
  );
}

export default App;
